export default "__VITE_ASSET__BtClJ0Xj__"